export default __webpack_public_path__ + "static/media/directions_ferry.2f2362f3.svg";